import React, { useState } from "react";
import { Layout } from "../../containers";
import { Container } from "./styled";
import secureLocalStorage from "react-secure-storage";
import { useHistory } from "react-router";
import styles from "../../styles/Home.module.scss";
import { Link } from "react-router-dom";
import { SuscriptionsPackages } from "../../components";

function Suscriptions() {
  const [activePlan, setActivePlan] = useState(null);
  const [isFormPopupActive, setIsFormPopupActive] = useState(false);
  const history = useHistory();
  const userLocal = secureLocalStorage.getItem("userLocal");

  async function handleSuscriptionClick(e, plan) {
    e.preventDefault();
    if (
      userLocal !== undefined &&
      userLocal !== null &&
      userLocal.plan !== plan
    ) {
      localStorage.setItem("planSelected", plan);
      if (plan === "Premium") {
        window.location.replace(
          "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=2c9380848cee0ea5018d12b797821a64"
        );
      }
    } else if (
      userLocal !== undefined &&
      userLocal !== null &&
      userLocal.plan === plan
    ) {
      alert(`Ya estas suscripto al plan: ${plan}`);
    } else if (userLocal === undefined || userLocal === null) {
      history.push("/app/register");
    }
  }

  return (
    <Layout>
      <Container>
        <div className="packages-section">
          <h2 className={styles.dynamicHeader}>
            Impulsa Tu Equipo y Maximiza Su Rendimiento Con Nuestras
            Suscripciones
          </h2>
          <SuscriptionsPackages />
        </div>
        {isFormPopupActive ? (
          <div className="popup-container">
            <div className="form-container">
              <h3>Contactate con ventas para tener más informacion.</h3>
              <form
                action="https://formsubmit.co/mmraverageman@gmail.com"
                method="POST"
              >
                <div className="personal-container">
                  <div className="buyer-name">
                    <div className="form-group">
                      <label>Nombre</label>
                      <input type="text" name="name" required />
                    </div>
                    <div className="form-group">
                      <label>Apellido</label>
                      <input type="text" name="lastname" required />
                    </div>
                    <div className="form-group mail">
                      <label>Mail</label>
                      <input type="email" name="mail" required />
                    </div>
                  </div>
                  <div className="form-group messagge">
                    <label>Mensaje</label>
                    <input type="text" name="messagge" required />
                  </div>
                </div>

                <div className="form-group">
                  <input
                    type="hidden"
                    name="_next"
                    value="https://deportacticoapp.vercel.app/ThankYou"
                  />
                </div>
                <div className="form-group">
                  <input
                    type="hidden"
                    name="_subject"
                    value="CONSULTA DE SUSCRIPCIÓN"
                  />
                </div>
                <div className="form-group ">
                  <input type="hidden" name="_captcha" value="false" />
                </div>
                <div className="form-group buttons">
                  <button
                    className="btn-primary ghost"
                    type="submit"
                    style={{ margin: "2rem auto" }}
                    onClick={(e) => setIsFormPopupActive(false)}
                  >
                    CANCELAR
                  </button>
                  <button
                    className="btn-primary"
                    type="submit"
                    style={{ margin: "2rem auto" }}
                  >
                    CONSULTAR
                  </button>
                </div>
              </form>
            </div>
          </div>
        ) : null}
      </Container>
    </Layout>
  );
}

export default Suscriptions;
